// bootstrap.js

"use strict";

import angular from "angular";
import { CONTRATACION_PUBLICA_SWENO_ENERGIA } from "../app";

angular.bootstrap(document, [CONTRATACION_PUBLICA_SWENO_ENERGIA], {
  strictDi: true
});
